import React, { useRef, useState } from "react";
import styled from "styled-components";
import * as API from "../../core/service/api.js";
import { } from "../../core/feature/store";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import {
  removeCompany,
  setCompany,
} from "../../core/feature/company/companySlice";
import logo from "../../assets/images/logo-default.svg";
import logoWhite from "../../assets/images/logo-white.svg";
import logoCompany from "../../assets/images/logo-company.svg";
import ellipse1 from "../../assets/images/icon_login/ellipse1.svg";
import ellipse2 from "../../assets/images/icon_login/ellipse2.svg";
import ellipse3 from "../../assets/images/icon_login/Ellipse3.svg";
import ellipse4 from "../../assets/images/icon_login/Ellipse4.svg";
import vector1 from "../../assets/images/icon_login/vector1.svg";
import Company from "../../core/models/company";
import { Link, useNavigate } from "react-router-dom";
import User from "../../core/models/user.js";
import { setUser } from "../../core/feature/user/userSlice";
import fingerPrint from "@fingerprintjs/fingerprintjs";
import Token from "../../core/models/token.js";
import { findIndex } from "lodash";
import { setToken } from "../../core/feature/token/tokenSlice";
import * as api_balance from "../../core/service/api_balance";
import { setBalance } from "../../core/feature/balance/balanceSlice";
import { toast } from "react-toastify";
import { Transition } from "@headlessui/react";
import { setLoading } from "../../core/feature/config/configSlice";
import { forgotPassword } from "../../core/service/api_profile";
import axios from "axios";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { BackButton } from "../common/BackButton.js";

const ComponentForgotPasswordConfirmation = () => {
  const emailRef = useRef<HTMLInputElement>(null);
  const whatsappRef = useRef<HTMLInputElement>(null);
  const newPasswordRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);
  const [sendOtp, setSendOtp] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [sender, setSender] = useState("WA");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const { t } = useTranslation();

  const sendOTP = async () => {
    if (sender == "WA" && phone == "") return toast.warning(t("LOGIN.otpWarn"));
    if (sender != "WA" && email == "") return toast.warning(t("LOGIN.otpWarn"));

    var query = {
      newPassword: "",
      otp: "",
      phoneEmail: sender == "WA" ? phone : email,
      sendVia: sender.toLowerCase(),
      reqTime: moment().format("HH:mm"),
    };
    dispatch(setLoading(true));
    forgotPassword(query)
      .then((res) => {
        dispatch(setLoading(false));
        navigate("/forgot-password-otp", {
          state: { data: JSON.stringify(query) },
        });
        toast.success(t("LOGIN.confirmSuccess"));
      })
      .catch((err) => {
        toast.error(t("LOGIN.confirmErr"));
        console.log(err);
        dispatch(setLoading(false));
      });
  };
  return (
    <div>
      <div className="relative font-poppins p-0 m-0 bg-psp-primary">
        <div className="flex min-h-screen">
          {/* <div>
            <img src={vector1} className="top-0 left-0 absolute z-10" />
          </div> */}
          <div className="relative overflow-visible w-3/12 sm:w-1/2 md:w-3/12 flex-0 bg-psp-login ">
            <img
              src={ellipse1}
              className="absolute bottom-0 left-0 z-0 select-none"
            />
            <img
              src={ellipse2}
              className="absolute top-0 left-0 z-0 select-none"
            />

            <div className="flex flex-col gap-10 w-full">
              <div className="flex flex-col z-10 gap-8 items-start">
                {/* <img src={vector1} className="ml-32 sm:ml-12 md:ml-32" /> */}
                <div className="px-10 mt-36 sm:px-10  md:px-10 md:mt-20 sm:mt-0">
                  <img src={logoWhite} className="z-10 h-14 select-none" />
                  <p className="text-white z-10 mt-6 text-xs font-light">
                    {t("LOGIN.description")}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex w-full p-12 bg-psp-primary relative">
            <img src={ellipse3} className="absolute top-0 -left-72 z-0" />
            <img src={ellipse4} className="absolute bottom-0 right-0 z-0" />
            <div className="w-1/2 md:w-2/3 sm:w-full m-auto z-10">
              <div className="pt-40">
                <h1 className="text-gray-400 text-2xl font-medium select-none">
                  Welcome To
                </h1>
                <p className="text-black font-semibold text-4xl select-none">
                  PSP Web Dekstop
                </p>
              </div>
              <div className="my-2">
                <h4 className="text-left text-lg font-semibold text-psp-primary select-none">
                  Login
                </h4>
              </div>
              <section className="flex flex-col mt-6">
                <h1 className="font-montserrat m-0 font-medium text-sm text-black text-left">
                  {t("LOGIN.otp1")}{" "}
                </h1>
                <div className="flex flex-col gap-2 mt-3">
                  <div className="flex flex-row gap-2">
                    <input
                      type="radio"
                      name="autoLogin"
                      value="WA"
                      id="WA"
                      checked={sender == "WA"}
                      onChange={(e) => setSender(e.target.value)}
                    />
                    <label
                      htmlFor="WA"
                      className="font-montserrat text-sm font-light"
                      onClick={() => setSender("WA")}
                    >
                      {t("LOGIN.wa")}
                    </label>
                  </div>
                  <input
                    hidden={sender != "WA"}
                    type={"number"}
                    onChange={(e) => setPhone(e.target.value + "")}
                    className="px-3 py-2 rounded-lg ml-5"
                  />
                  <div className="flex flex-row gap-2">
                    <input
                      type="radio"
                      name="autoLogin"
                      value="EMAIL"
                      id="EMAIL"
                      onChange={(e) => setSender(e.target.value)}
                    />
                    <label
                      htmlFor="EMAIL"
                      className="font-montserrat text-sm font-light"
                      onClick={() => setSender("EMAIL")}
                    >
                      {t("LOGIN.mail")}
                    </label>
                  </div>
                  <input
                    type={"email"}
                    hidden={sender != "EMAIL"}
                    onChange={(e) => setEmail(e.target.value)}
                    className="ml-5 px-3 py-2 rounded-lg"
                  />
                </div>
                <button
                  onClick={() => sendOTP()}
                  className="mt-4 bg-psp-btn-primary text-white font-bold w-full py-2 rounded-lg hover:text-red-600 hover:ring-2 hover:ring-offset-cyan-600  active:bg-psp-active"
                >
                  {t("LOGIN.otp")}
                </button>
                <button
                  onClick={() => navigate(-1)}
                  className="mt-2 bg-[#FFC31A] text-white font-bold w-full py-2 rounded-lg hover:text-red-600 hover:ring-2 hover:ring-offset-cyan-600  active:bg-psp-active"
                >
                  {t("OTHER.back")}
                </button>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComponentForgotPasswordConfirmation;
